import React from 'react';
import { connect } from 'react-redux';
//svgs
import SmallHeader from '../../../svgs/tracking/SmallHeader'
import TemplateControl from './TemplateControl';
import { THEMES } from '../../../dto/theme';
function GenerateForm({control,inPending, permissionObj ,form, isPreview, updateFieldDataDataWithKey=() => {}, updateFieldData=()=>{}, formIndex=0}) {
    return (<div className='mr-4'>
        {form?.map((sectionObj, sectionIdx) => { 
            let disabling = isPreview
            if(!isPreview && (sectionObj.permission === 'Issuers' && !permissionObj.userIsIssuer)) disabling = true
            if(!isPreview && (sectionObj.permission === 'Approvers' && !permissionObj.userIsApprover)) disabling = true
            if(!isPreview && (sectionObj.permission === 'Receivers' && !permissionObj.userIsReceiver)) disabling = true
            if(inPending) disabling = true
            return(
                <div key={'f_'+formIndex+sectionObj.id} className='py-[32px]' style={{color: control.theme === THEMES.DARK ? '#FFFFFF' : '#000000'}}>
                    <div className={`flex flex-col border-b ${control.theme === THEMES.DARK ? 'border-[#FFFFFF80]' : 'border-[#00000080]'} pb-[16px]`}>
                        <div className='flex flex-row text-[18px] font-bold' style={{color:control.theme===THEMES.DARK?'#fff':'#000'}}><SmallHeader className="mr-[4px]" color={control.theme===THEMES.DARK?'#fff':'#000'}/> {sectionObj.sectionTitle}</div>
                        <div className='text-[12px] ml-[16px] pl-[16px]' style={{color:control.theme === THEMES.DARK ? '#797979' : '#000'}}>{sectionObj.sectionDescription}</div>
                    </div>
                    <div className='flex flex-row flex-wrap'>
                        {sectionObj.data.map((fieldObj, fieldIdx) => (
                            <TemplateControl key={'f_'+formIndex+'_'+'fieldObj' + fieldIdx} isPreview={disabling} sectionIdx={sectionIdx} fieldIdx={fieldIdx} fieldObj={fieldObj} updateFieldDataDataWithKey={updateFieldDataDataWithKey} updateFieldData={updateFieldData}/>
                        ))}
                    </div>
                </div>
            )}
        )}
    </div>)
}

export default connect((store) => {
    return {
      token: store.tokenReducer,
      control: store.controlReducer,
    }
  })(GenerateForm)